import { defineMessages } from 'react-intl'

const scope = `modules.expense.features.revise-expense-report.presenters.ReviseExpenseReportPresenter`

export default defineMessages({
  revisingBadge: {
    id: `${scope}.revisingBadge`,
    defaultMessage: 'Revising',
  },
  deniedBadge: {
    id: `${scope}.deniedBadge`,
    defaultMessage: 'Denied',
  },
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: 'Expense request #{id} has been resubmitted',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  missingDepartmentErrorMessage: {
    id: `${scope}.missingDepartmentErrorMessage`,
    defaultMessage: 'Please select a department',
  },
  resubmitButton: {
    id: `${scope}.resubmitButton`,
    defaultMessage: 'Resubmit',
  },
})
